import {useCallback} from 'react';

import {useCommonDataHook} from 'src/hooks/use-common-data-hook';
import {getPitchBookCrmSettings, savePitchBookCrmSettings} from 'src/openapi/admin/apis/PitchBookControllerApi';
import {useAppDispatch} from 'src/store/hooks';

import type {PitchBookCrmSettings} from 'src/openapi/admin/models/PitchBookCrmSettings';

type Props = {
    accountId: number,
};

export const usePitchBookCrmSettings = ({accountId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => apiDispatch(
        getPitchBookCrmSettings({accountId}),
    ), [accountId, apiDispatch]);

    const saveDispatchAction = useCallback(async (pitchBookCrmSettings: PitchBookCrmSettings) => await apiDispatch(
        savePitchBookCrmSettings({
            accountId,
            pitchBookCrmSettings,
        }),
    ), [accountId, apiDispatch]);

    return useCommonDataHook({
        getDispatchAction,
        saveDispatchAction,
        shouldLoadData: false,
        initValue: {
            accountPrivacyEnabled: false,
            groupPrivacyEnabled: false,
            userPrivacyEnabled: false,
        },
    });
};
